<div class="bs-section-body" fxLayout="row reverse-wrap" fxLayoutAlign="end end">
  <ng-content></ng-content>
</div>

<hr *ngIf="index < nMenus - 1" class="mb-32px" />
